import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, ease: 'easeOut' },
  },
};

export default function Legal() {
  return (
    <div style={{ backgroundColor: '#0A0F1C' }}>
      {/* Page header */}
      <section
        className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 text-center"
        style={{ backgroundColor: '#070C18', borderBottom: '1px solid rgba(204,0,0,0.2)' }}
      >
        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: '#CC0000' }}>
            Legal
          </p>
          <h1
            className="text-5xl sm:text-6xl font-bold text-white mb-4"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            Terms of Use and Privacy Policy
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Last updated 6 July 2026
          </p>
        </motion.div>
      </section>

      {/* Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <motion.div
          className="max-w-3xl mx-auto text-gray-300 text-base leading-relaxed"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <h2
            className="text-3xl font-bold text-white mt-2 mb-4"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            Privacy Policy
          </h2>
          <p className="mb-4">
            Auto Doctor Ltd ("Auto Doctor", "we", "us") respects your privacy and is committed to
            protecting the personal information you share with us through this website, in line
            with the New Zealand Privacy Act 2020.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Information We Collect</h3>
          <p className="mb-4">
            When you use the contact form on this website, we collect the information you
            voluntarily provide, which may include your name, email address, phone number, and
            the content of your message. We do not collect any information from you that you do
            not directly provide.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">How We Use Your Information</h3>
          <p className="mb-4">
            We use the information you submit solely to respond to your enquiry, arrange
            bookings, or provide the service you have requested. We do not sell, rent, or trade
            your personal information to third parties, and we do not use it for marketing
            without your consent.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">How We Store Your Information</h3>
          <p className="mb-4">
            Contact form submissions are processed and stored securely by our website hosting and
            forms provider, Netlify, and are accessible only to Auto Doctor staff who need them to
            respond to your enquiry. We retain enquiry information only as long as reasonably
            necessary to deal with your request and for our business record-keeping obligations.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Your Rights</h3>
          <p className="mb-4">
            Under the Privacy Act 2020, you have the right to request access to, or correction of,
            any personal information we hold about you. To make such a request, or if you have any
            questions about this policy, please contact us at{' '}
            <a href="mailto:admin@autodoctor.co.nz" className="underline" style={{ color: '#CC0000' }}>
              admin@autodoctor.co.nz
            </a>{' '}
            or on{' '}
            <a href="tel:042935987" className="underline" style={{ color: '#CC0000' }}>
              04-293 5987
            </a>
            .
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Cookies and Analytics</h3>
          <p className="mb-4">
            This website may use standard, privacy-friendly analytics to understand general site
            usage. No personal information is collected through this process beyond standard,
            anonymised web traffic data.
          </p>

          <h2
            className="text-3xl font-bold text-white mt-14 mb-4"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            Terms of Use
          </h2>
          <p className="mb-4">
            By using this website, you agree to the following terms. If you do not agree with
            these terms, please do not use this website.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Website Content</h3>
          <p className="mb-4">
            The content on this website is provided for general information about Auto Doctor Ltd
            and our services. While we make reasonable efforts to keep information accurate and
            up to date, we make no warranties about the completeness or accuracy of the content,
            and pricing, availability, or service details may change without notice. For an exact
            quote or current information, please contact us directly.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Acceptable Use</h3>
          <p className="mb-4">
            You agree to use this website only for lawful purposes and not to submit any false,
            misleading, or malicious content through our contact form.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Intellectual Property</h3>
          <p className="mb-4">
            All content on this website, including text, images, and logos, is owned by or
            licensed to Auto Doctor Ltd and may not be reproduced without permission.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Limitation of Liability</h3>
          <p className="mb-4">
            To the extent permitted by law, Auto Doctor Ltd is not liable for any loss or damage
            arising from your use of this website. Nothing in these terms limits any rights you
            may have under the Consumer Guarantees Act 1993 or the Fair Trading Act 1986 that
            cannot be excluded.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Changes to These Terms</h3>
          <p className="mb-4">
            We may update this Privacy Policy and these Terms of Use from time to time. The
            version published on this page is the current version.
          </p>

          <h3 className="text-xl font-semibold text-white mt-8 mb-3">Contact</h3>
          <p>
            If you have any questions about these terms or our privacy practices, please contact
            us at{' '}
            <a href="mailto:admin@autodoctor.co.nz" className="underline" style={{ color: '#CC0000' }}>
              admin@autodoctor.co.nz
            </a>{' '}
            or visit us at 22 Parata Street, Waikanae.
          </p>
        </motion.div>
      </section>
    </div>
  );
}
